import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";

export const FormShell = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.spacing(2),
  border: `1px solid ${theme.palette.divider}`,
}));
